<template>
    <div>
        <table colspacing="2" colpadding="2" border="1" width="100%" style="text-align: center;">
            <tr>
                <th>Height</th>     
                <th colspan="3">Weight (lbs.)</th>   
            </tr>   
            <tr><td>4' 10</td><td>119-142</td><td>143-190</td><td>191</td></tr>
            <tr><td>4' 11</td><td>124-147</td><td>148-197</td><td>198</td></tr>
            <tr><td>5' 0</td><td>128-152</td><td>153-203</td><td>204</td></tr>
            <tr><td>5' 1</td><td>132-157</td><td>158-210</td><td>211</td></tr>
            <tr><td>5' 2</td><td>136-163</td><td>164-217</td><td>218</td></tr>
            <tr><td>5' 3</td><td>141-168</td><td>169-224</td><td>225</td></tr>
            <tr><td>5' 4</td><td>145-173</td><td>174-231</td><td>232</td></tr>
            <tr><td>5' 5</td><td>150-179</td><td>180-239</td><td>240</td></tr>
            <tr><td>5' 6</td><td>155-185</td><td>186-246</td><td>247</td></tr>
            <tr><td>5' 7</td><td>159-190</td><td>191-254</td><td>255</td></tr>
            <tr><td>5' 8</td><td>164-196</td><td>197-261</td><td>262</td></tr>
            <tr><td>5' 9</td><td>169-202</td><td>203-269</td><td>270</td></tr>
            <tr><td>5' 10</td><td>174-208</td><td>209-277</td><td>278</td></tr>
            <tr><td>5' 11</td><td>179-214</td><td>215-285</td><td>286</td></tr>
            <tr><td>6' 0</td><td>184-220</td><td>221-293</td><td>294</td></tr>
            <tr><td>6' 1</td><td>189-226</td><td>227-301</td><td>302</td></tr>
            <tr><td>6' 2</td><td>194-232</td><td>233-310</td><td>311</td></tr>
            <tr><td>6' 3</td><td>200-239</td><td>240-318</td><td>319</td></tr>
            <tr><td>6' 4</td><td>205-245</td><td>246-327</td><td>328</td></tr>
            <tr>
                <td>&nbsp;</td><td><strong>(1 Point)</strong></td><td><strong>(2 Point)</strong></td><td><strong>(3 Point)</strong></td>
            </tr>
            <tr>
                <td>&nbsp;</td> 
                <td colspan="3" style="text-align: center;">You weigh less than the amount in the left column</br>(0 points)</td>
          </tr>
        </table>    
    </div> 
</template>

<script>
export default {
    name: "weightTable"
}
</script>


<style>

th{
    background-color: #00a9e0;
    color: #ffffff;
}
</style>